import { useEffect, useRef, useState } from 'react';

import { Card } from '../../components/Card';
import TimerProgressBar from '../../components/timerProgressBar/TimerProgressBar';
import { Text } from '../../components/Text';
import { pushFaroEvent } from '../../faroSession';
import { PlayButtonIcon } from '../../assets/icons';
import classes from './SummaryScreen.module.css';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../redux/store';
import { changePageDetails } from '../../redux/appConfigSlice';

interface SummaryScreenProps {
    isVideoPlayed: boolean;
    setIsVideoPlayed: (val: boolean) => void;
}

const productGuidanceVideo: Record<string, string> = {
    GT: '/assets/videos/gt_guidance_video.webm',
    GT_TRIAL: '/assets/videos/gt_guidance_video.webm',
    HOELT: '/assets/videos/hoelt_guidance_video.webm',
};

// Summary screen component that displays the summary of the selected options.
const SummaryScreen = (props: SummaryScreenProps) => {
    const videoRef = useRef<HTMLVideoElement | null>(null);
    const dispatch = useDispatch();
    const { pageObject, insperaDetails } = useSelector((state: RootState) => state.appConfigSlice);

    const [videoPlaying, setVideoPlaying] = useState(false);

    /**
     * Code to set a state variable for video duration of 'videoPath'.
     * Default value of videoDuration is 112 seconds, which is the length of the 'videoPath' video.
     * If this video changes then update the default value of videoDuration with new video duration.
     */

    // Changing this to 10 for now as we are using the 10 sec video
    const [videoDuration, setVideoDuration] = useState(106);

    /**
     * Check if the mini version the envroment variable is true then show mini guidance video
     */

    // Commenting for now while waiting for the longer webm format
    let guidanceVideoURL;

    if (insperaDetails.product === 'HOELT' && String(process.env.REACT_APP_IS_FULL_LENGTH_HOELT_VIDEO) === 'true') {
        guidanceVideoURL = productGuidanceVideo.HOELT;
    } else if (String(process.env.REACT_APP_IS_PP) === 'true') {
        guidanceVideoURL = productGuidanceVideo[insperaDetails.product] ?? productGuidanceVideo.GT;
    } else {
        guidanceVideoURL = '/assets/videos/gt_guidance_video_mini.webm';
    }


    useEffect(() => {
        if (!props.isVideoPlayed) {
            dispatch(
                changePageDetails({
                    ...pageObject,
                    disableSummaryScreenButton: true,
                }),
            );
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Card className={classes.container}>
            {!props?.isVideoPlayed && (
                <>
                    <Text text="You can watch the video once only." />
                    <div className={classes.videoPlayer}>
                        <div className={classes.videoContainer}>
                            <video
                                data-testid="speakingtest-readiness-video"
                                className={classes.video}
                                ref={videoRef}
                                src={guidanceVideoURL}
                                onPlay={() => {
                                    setVideoPlaying(true);
                                }}
                                onEnded={() => {
                                    props.setIsVideoPlayed(true);
                                    dispatch(
                                        changePageDetails({
                                            ...pageObject,
                                            disableSummaryScreenButton: false,
                                        }),
                                    );
                                }}
                                onLoadedMetadata={() => {
                                    pushFaroEvent('guidance_video_duration_loaded', { 
                                        duration: String(videoRef.current?.duration)
                                    });
                                    if (videoRef.current) {
                                        setVideoDuration(Math.round(videoRef.current?.duration));
                                    }
                                }}
                            >
                                <track kind="captions" />
                            </video>
                            {!videoPlaying && (
                                <div className={classes.overlay}>
                                    <button className={classes.playerBtn} onClick={() => videoRef.current?.play()}>
                                        <PlayButtonIcon className={classes.btnIcon} />
                                    </button>
                                </div>
                            )}
                        </div>
                        <TimerProgressBar
                            play={videoPlaying}
                            timerBarDuration={videoDuration}
                            showTime={true}
                            endTime={videoDuration}
                            className={classes.videoDuration}
                        />
                    </div>
                </>
            )}

            {props?.isVideoPlayed && <Text text="Click <b>Next</b> to begin your Speaking test." />}
        </Card>
    );
};

export default SummaryScreen;
